module.exports = __webpack_public_path__ + "img/alterna-ai-logo-white.ffa8103e.png";